export function listVideoClasses() {
    let listVideos = $('.videos-list');
    listVideos.find('li').hover(function () {
        // console.log('hover');
    }, function () {
        // console.log('unhover');
        listVideos.find('span').text('play trailer');
        listVideos.find('iframe').attr('src', '');
        listVideos.find('.trailer-video').removeClass('show-trailer');
    });

    // listVideos.find('.play-icon').on('click', function (e) {
    //     e.preventDefault();
    //     let _this = $(this);
    //     let $parent = _this.closest('.trailer-video');
    //     $parent.find('span').text('Loading...');
    //     $parent.addClass('show-trailer').find('iframe').attr('src', $parent.attr('data-video'));
    // });

    let $coupons_list = $(".coupons-list");
    if ($coupons_list.length) {
        $coupons_list.slick({
            fade: true,
            dots: false,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            autoplaySpeed: 5000,
            prevArrow: $(".holder-coupons-list .common-slider-controls .prev-arrow"),
            nextArrow: $(".holder-coupons-list .common-slider-controls .next-arrow")
        });

        $('.details').on('click', function (e) {
            e.preventDefault();
            $('.details-info').slideToggle();
        });
    }

    let $list_digital_workbooks = $(".list-digital-workbooks");
    if ($list_digital_workbooks.length) {
        $list_digital_workbooks.slick({
            fade: true,
            dots: false,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            autoplaySpeed: 5000,
            prevArrow: $(".holder-digital-workbooks .common-slider-controls .prev-arrow"),
            nextArrow: $(".holder-digital-workbooks .common-slider-controls .next-arrow")
        });
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/video-classes.js